import { CashInCashOutType } from '@nemuru-eng/js-api-client';
import React from 'react';

import { Text } from '../../../shared/components/Text';

export const CashInCashOutTypeOptions = Object.values(CashInCashOutType).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
